import Input from '../../components/core/input'
import {SimpleBlueButton} from '../../components/core/button'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import {Formik} from 'formik'
import {useState} from 'react'
import {codeSchema} from '../../utils/validation'
import {useDispatch} from 'react-redux'
import {getPersonalNotificationChannels, verifyNotificationCode} from '../../stores/customer-settings'
import InfoBox from './infoBox'
import {trimStringValues} from '../../utils/text'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const CodePopup = ({data, setModalData, customerId, isTeamChannel}) => {
    const text = useNamespaceTranslations('notifications')
    const [buttonIsDisabled, setButtonIsDisabled] = useState(false)
    const dispatch = useDispatch()

    const initialFormValues = {
        code: '',
        priority: data?.channel?.priority
    }

    const inputInfoTexts = {
        email: text.code_info_email,
        sms: text.code_info_sms,
        phone: text.code_info_phone,
        telegram: text.code_info_telegram
    }

    const verifyCode = async(values, {setFieldError, resetForm}) => {
        setButtonIsDisabled(true)
        const success = await dispatch(verifyNotificationCode(isTeamChannel, customerId, trimStringValues(values), setFieldError))
        setButtonIsDisabled(false)
        if (success) {
            resetForm()
            setModalData({})
            await dispatch(getPersonalNotificationChannels(isTeamChannel, false, customerId))
        }
    }

    return (
        <Formik initialValues={initialFormValues}
            onSubmit={verifyCode}
            enableReinitialize={true}
            validationSchema={codeSchema}
            validateOnBlur={false}
            validateOnChange={false}>
            {({values, errors, handleSubmit, handleChange}) => (
                <form onSubmit={handleSubmit} className="modal-body">
                    <InfoBox value={data?.value} type={data?.type}/>
                    <Input
                        name="code"
                        value={values.code}
                        onChange={handleChange}
                        error={errors.code}
                        placeholder={text.code}
                        infoText={inputInfoTexts[data?.type]}/>
                    <SimpleBlueButton disabled={buttonIsDisabled}
                        type="submit">
                        {buttonIsDisabled && <ButtonLoader/>}
                        {text.submit}
                    </SimpleBlueButton>
                </form>
            )}
        </Formik>
    )
}

export default CodePopup
